<template>
  <div class="is-taisyokukin edit-item" v-if="editingData && options">

    <div class="head"><b>退職金</b></div>
    <div class="data flex flex-align-center">
      <select-box :options="options.boolean_type" v-model="editingData.is_taisyokukin" class="small" :disabled="disabled"></select-box>
      <p v-if="editingData.is_taisyokukin" class="scale">（勤続3年以上の場合に支給）</p>
    </div>

  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null,
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
